import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import CTABanner from "./components/CTABanner";
import WhoCanParticipate from "./components/WhoCanParticipate";
import WhyParticipate from "./components/WhyParticipate";
import EventInfo from "./components/EventInfo";
import AboutFourModels from "./components/AboutFourModels";
import SuccessStories from "./components/SuccessStories";
import FinalStage from "./components/FinalStage";
import UrgencyCTA from "./components/UrgencyCTA";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <CTABanner />
        <WhoCanParticipate />
        <WhyParticipate />
        <EventInfo />
        <AboutFourModels />
        <SuccessStories />
        <FinalStage />
        <UrgencyCTA />
      </main>
      <Footer />
    </div>
  );
}
